/***************************************************************************************************/
/*                                 App Detail Menu                                                 */
/***************************************************************************************************/
// tslint:disable:max-line-length
// tslint:disable:no-empty-interface
// tslint:disable: no-use-before-declare
import { TCITenantAppType } from "./tci-application";
import {
    AbstractTCITenantComponentOptions,
    ITCIApplicationRequest,
    ITCIApplicationResponse,
    ITCIOptionType,
    ITCITenantComponentOptions,
    ITCITenantModalOptions,
    ITCITenantModalType,
    ITCITenantServiceProvider,
    TCITenantModalType,
    TCITenantSelectorType
} from "./tci-tenant";
import { Observable } from "rxjs";

/**
 * Enumeration of TCI menu types
 */
export const TCI_APP_DETAIL_MENU_TYPE: ITCIOptionType<string> = {
    MAIN_MENU: "main",
    HAMBURGER_MENU: "hamburger"
};
export type TCI_APP_DETAIL_MENU_TYPE = keyof typeof TCI_APP_DETAIL_MENU_TYPE;

/**
 * class TCITenantAppDetailsMenu
 */
export class TCITenantAppDetailsMenu
    extends AbstractTCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>
    implements ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>,
    ITCITenantModalOptions {
    public static TCI_MENU_APP_DETAILS_FLOWS = new TCITenantAppDetailsMenu("Flows", TCITenantSelectorType.TCI_APP_DETAIL_FLOWS, 1, "flows", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
        TCITenantAppType.node
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_PROCESSES = new TCITenantAppDetailsMenu("Processes", TCITenantSelectorType.TCI_APP_DETAIL_PROCESSES, 2, "processes", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_ENDPOINTS = new TCITenantAppDetailsMenu("Endpoints", TCITenantSelectorType.TCI_APP_DETAIL_ENDPOINTS, 2, "endpoints", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_CONNECTIONS = new TCITenantAppDetailsMenu("Connections", TCITenantSelectorType.TCI_APP_DETAIL_CONNECTIONS, 4, "connections", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_LOGS = new TCITenantAppDetailsMenu("Logs", TCITenantSelectorType.TCI_APP_DETAIL_LOGS, 5, "logs", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_ELASTIC_LOGS = new TCITenantAppDetailsMenu("Logs", TCITenantSelectorType.TCI_APP_DETAIL_ELASTIC_LOGS, 5, "elastic_logs", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_HISTORY = new TCITenantAppDetailsMenu("History", TCITenantSelectorType.TCI_APP_DETAIL_HISTORY, 6, "history", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_ENVIRONMENT = new TCITenantAppDetailsMenu("Environment controls", TCITenantSelectorType.TCI_APP_DETAIL_ENVIRONMENT, 4, "envcontrols", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_MONITORING = new TCITenantAppDetailsMenu("Monitoring", TCITenantSelectorType.TCI_APP_DETAIL_MONITORING, 3, "metrics", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_EXEC_HISTORY = new TCITenantAppDetailsMenu("Execution History", TCITenantSelectorType.TCI_APP_DETAIL_EXEC_HISTORY, 9, "exechistory", [
        TCITenantAppType.scribe,
        TCITenantAppType.flogo,
        TCITenantAppType.bw
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_DESIGNER = new TCITenantAppDetailsMenu("Designer", TCITenantSelectorType.TCI_APP_DETAIL_DESIGNER, 9, "designer", [
        TCITenantAppType.liveapps
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_ALERT = new TCITenantAppDetailsMenu("Alerts", TCITenantSelectorType.TCI_APP_DETAIL_ALERT, 10, "alerts", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);


    public static TCI_MENU_APP_DETAILS_MARK_AS_LIVE = new TCITenantAppDetailsMenu("Set deployment stage", TCITenantSelectorType.TCI_APP_DETAIL_MARK_LIVE, 1, "mark_live", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_SMALL);
    public static TCI_MENU_APP_DETAILS_CHG_ENDPOINT_VISIBILITY = new TCITenantAppDetailsMenu("Set endpoint visibility", TCITenantSelectorType.TCI_APP_DETAIL_SET_ENDPOINT, 5, "endpoint_visibility", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_SMALL);
    public static TCI_MENU_APP_DETAILS_COPY_APPLICATION = new TCITenantAppDetailsMenu("Copy", TCITenantSelectorType.TCI_APP_DETAIL_COPY_APPLICATION, 2, "copy_app", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node,
        TCITenantAppType.liveapps
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_REPLACE_APPLICATION = new TCITenantAppDetailsMenu("Replace", TCITenantSelectorType.TCI_APP_DETAIL_REPLACE_APPLICATION, 3, "replace_app", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_TRANSFER_OWNERSHIP = new TCITenantAppDetailsMenu("Change owner", TCITenantSelectorType.TCI_APP_DETAIL_TRANSFER_OWNERSHIP, 4, "transfer_ownership", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_UPLOAD_EXISTING_APPLICATION = new TCITenantAppDetailsMenu("Upload Modified App", TCITenantSelectorType.TCI_APP_DETAIL_UPLOAD_EXISTING_APP, 7, "upload_existing_app", [
        TCITenantAppType.bw,
        TCITenantAppType.node
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAIL_SCRIBE_REQUEST_LOGS = new TCITenantAppDetailsMenu("Request Agent Logs", TCITenantSelectorType.TCI_APP_DETAIL_SCRIBE_REQUEST_LOGS, 8, "scribe_request_logs", [
        TCITenantAppType.scribe,
        // TCITenantAppType.node // For HM Item Inline tests only
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_INLINE);
    public static TCI_MENU_APP_DETAILS_SCHEDULE = new TCITenantAppDetailsMenu("Schedule", TCITenantSelectorType.TCI_APP_DETAIL_SCHEDULE, 9, "scribeschedule", [
        TCITenantAppType.scribe
    ], TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_MENU_APP_DETAILS_CREATE_LISTING = new TCITenantAppDetailsMenu("Create Marketplace Listing", TCITenantSelectorType.TCI_APP_DETAIL_CREATE_LISTING, 2, "create_listing", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.scribe,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_MARKETPLACE);
    public static TCI_MENU_APP_DETAILS_EDIT = new TCITenantAppDetailsMenu("Edit", TCITenantSelectorType.TCI_APP_DETAIL_EDIT, 4, "edit_app", [
        TCITenantAppType.liveapps,
        TCITenantAppType.node
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_SMALL);
    public static TCI_MENU_APP_DETAILS_SHARE_EXTERNALLY = new TCITenantAppDetailsMenu("Share Externally", TCITenantSelectorType.TCI_APP_DETAIL_SHARE_EXTERNALLY, 5, "share_externally", [
        TCITenantAppType.liveapps,
        TCITenantAppType.node
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_SMALL);
    public static TCI_MENU_APP_DETAILS_RENAME_APPLICATION = new TCITenantAppDetailsMenu("Rename", TCITenantSelectorType.TCI_APP_DETAIL_RENAME_APPLICATION, 6, "rename_app", [
        TCITenantAppType.liveapps,
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node,
    ], TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU, TCITenantModalType.TCI_MODAL_SMALL);

    private static allItems = [
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_FLOWS,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_PROCESSES,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_ENDPOINTS,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_CONNECTIONS,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_MONITORING,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_ENVIRONMENT,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_LOGS,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_ELASTIC_LOGS,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_ALERT,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_HISTORY,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_SCHEDULE,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_EXEC_HISTORY,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_DESIGNER,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAIL_SCRIBE_REQUEST_LOGS,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_MARK_AS_LIVE,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_COPY_APPLICATION,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_REPLACE_APPLICATION,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_EDIT,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_SHARE_EXTERNALLY,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_RENAME_APPLICATION,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_TRANSFER_OWNERSHIP,
        TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_CHG_ENDPOINT_VISIBILITY,
        // TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_CREATE_LISTING,
        // TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_UPLOAD_EXISTING_APPLICATION
    ];

    /**
     * Gets All menu items
     * @param menuType
     * @return @ITCITenantMenu[]
     */
    public static getAllMenuItems(menuType?: TCI_APP_DETAIL_MENU_TYPE): ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>[] {
        if (menuType) {
            return TCITenantAppDetailsMenu.allItems.filter((v) => {
                return v.getOptionType() === menuType;
            });
        }
        return TCITenantAppDetailsMenu.allItems;
    }

    /**
     * constructor
     * @param menuOption
     * @param componentSelectorType
     * @param position
     * @param routeId
     * @param tenantAppTypes
     * @param menuType
     * @param modalType
     */
    constructor(menuOption: string,
        componentSelectorType: TCITenantSelectorType,
        position: number,
        routeId: string,
        tenantAppTypes: TCITenantAppType[],
        menuType: TCI_APP_DETAIL_MENU_TYPE = TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU,
        private modalType: ITCITenantModalType = TCITenantModalType.TCI_MODAL_MEDIUM) {
        super(menuOption, componentSelectorType, position, menuType, routeId, tenantAppTypes, null);
    }

    getModalType(): ITCITenantModalType {
        return this.modalType;
    }
}

/*************************************************************************************************/
/**
 * interface ITCIApplicationDetailRequest
 */
export interface ITCIApplicationDetailRequest extends ITCIApplicationRequest {
}

/**
 * interface ITCIApplicationDetailResponse
 */
export interface ITCIApplicationDetailResponse extends ITCIApplicationResponse {
}

/**
 *  Application Detail Provider
 *  @deprecated
 */
export interface ITCIApplicationDetailProvider extends ITCITenantServiceProvider {

    canProvideApplicationDetails(input: TCITenantAppType): Observable<boolean>;

    providerApplicationDetails(input: ITCIApplicationDetailRequest): Observable<ITCIApplicationDetailResponse>;

}
